export default "__VITE_ASSET__CtR52yWk__"